import democracy_contract from '../../../../build/contracts/Democracy.json'
import store from '../../../store'

const contract = require('truffle-contract')

export const ADD_PROPOSALS = 'ADD_PROPOSALS'
function proposalsUpdated(proposals) {
    return {
        type: ADD_PROPOSALS,
        payload: proposals
    }
}

function getDeadline(cInstance, dispatch, oldProposals, page, allProposals, next, perProposal){
	
    let proposals = []
	
    for(let i = allProposals; i > next; i--) {
        cInstance.checkProposalDeadline(i).then((result) => {
			
            let obj = oldProposals.find( proposal => proposal.proposalId === i );
            Object.assign(obj, {isDeadlineOver: result});
			
            proposals.push(obj)
			
            if (perProposal === proposals.length){
                proposals.sort(function(a, b){
                    return b.proposalId-a.proposalId
                })

                return dispatch(proposalsUpdated({'proposals':proposals,'activePage':page}))
            }
			
        })
    }
}

function getAll(cInstance, dispatch, page, i, proposalsAll, allProposals, next, perProposal, contractAddress, web3){

    cInstance.proposals(i).then((result) => {
			
        let amount = parseFloat(web3.fromWei(result[5].toString()));
        let amountEth = amount + " ETH"
		
        let recipient = result[0].toString();
        if(recipient === contractAddress){
            recipient = 'No recipient'
        }

        proposalsAll.push({recipient:recipient,amount:amountEth,description:result[2].toString(),voteYes:result[8].toString(),
		voteNo:result[9].toString(),allVotes:result[6].toString(),minimumVotes:result[7].toString(),isExecuted:result[1],deadline:result[4].toString(),
		proposalId:i});

        if (perProposal === proposalsAll.length){
			
            getDeadline(cInstance, dispatch, proposalsAll, page, allProposals, next, perProposal)
			//return dispatch(proposalsUpdated({'proposals':proposals,'activePage':page}))
        }
		
    })

}

export function getProposals(allProposals, page) {
  
    let web3 = store.getState().web3.web3Instance

    if (typeof web3 !== 'undefined') {

        return function(dispatch) {

            let cInstance
            let perProposal = 5
            let proposalsAll = []
            let more = perProposal * page
            let next = allProposals - more
            if (page > 1){
                let prev = page - 1
                allProposals -= perProposal * prev
            }
            if (next <= 0){
                next = 0
                perProposal = allProposals
            }
		
            const DemocracyContract = contract(democracy_contract)
            DemocracyContract.setProvider(web3.currentProvider)


            DemocracyContract.deployed().then((contractInstance) => {
                cInstance = contractInstance	
			
                let contractAddress = cInstance.address
			
                for(let i = allProposals; i > next; i--) {
                    getAll(cInstance, dispatch, page, i, proposalsAll, allProposals, next, perProposal, contractAddress, web3)
                }

            })
		
        }
    } else {
        console.error('Web3 is not initialized.');
    }
}



// WEBPACK FOOTER //
// ./src/user/actions/city/GetProposals.js